import { req } from '../../@api/request';

export default class InquiryService {
  static inquiry = async (data: any) => {
    const result = await req.post('/inquiry', data);
    return result.data;
  };

  static fetchMyInquiries = async (startDate: string, endDate: string) => {
    const result = await req.get2('/inquiry/list', {
      params: { startDate, endDate },
    });
    return result.data;
  };

  static updateInquiryStatus = async (
    inquiryId: string,
    payload: { status: string },
  ) => {
    const result = await req.patch(`/inquiry/${inquiryId}`, payload);
    return result.data;
  };
}
